import React, { useState } from "react";
import PropTypes from "prop-types";

import DisplayPicture from "../DisplayPicture/DisplayPicture";

import style from "./Comment.module.css";

import { callAPI } from "../../assets/Js/backendCommunication";
import projectSettings from "../../assets/Js/projectSettings";
import { getPlainToken } from "../../assets/Js/tokenHandler";

export default function Comment({ CommentInfo, ItemKey }) {
  const { Image, UserName, Comments, ImageUrl, LikeCount, HasLiked, Id } =
    CommentInfo;
  const [didLike, setDidLike] = useState(HasLiked);
  const [numberOfLikes, setNumberOfLikes] = useState(LikeCount);

  const likeClicked = async () => {
    let url = `${projectSettings.baseUrl}/comments/likesave`;
    let header = true;
    let type = "POST";
    let token = getPlainToken();
    let data = null;

    let response = "";

    data = {
      commentId: Id,
      liked: !didLike,
    };

    updateValues();

    response = await callAPI(url, header, type, JSON.stringify(data), token);

    if (response) {
      if (response.type === "error") {
        updateValues();
      } else if (response.type === "success") {
        response = "";
      }
    }
  };

  const updateValues = async () => {
    setDidLike((prevVal) => !prevVal);
    setNumberOfLikes((prevVal) => {
      if (didLike) {
        return --prevVal;
      } else {
        return ++prevVal;
      }
    });
  };

  return (
    <div key={ItemKey}>
      <div className="d-flex align-items-center mt-1 mb-1">
        <DisplayPicture image={Image} className="profileImageSmall" />
        <div className="ml-2">
          <b>{UserName}:</b>
        </div>
        <div className="ml-1">{Comments && Comments}</div>
      </div>
      {ImageUrl && <DisplayPicture gif={ImageUrl} className={style.gifStyle} />}
      <div className="commentLikeStyle colorMedium">
        <div
          className={`mr-4 pointerCursor noHighLight h6 ${
            didLike && "primaryColor"
          }`}
          onClick={likeClicked}
        >
          <i className={`mdi mdi-thumb-up mr-2`}></i>
          <span className="mr-1">{numberOfLikes}</span>
          Like
          {numberOfLikes > 1 && "s"}
        </div>
      </div>
    </div>
  );
}

Comment.propTypes = {
  CommentInfo: PropTypes.object,
  ItemKey: PropTypes.string,
};
